import { useTranslation } from 'react-i18next';
import { Button } from '../../../ui/button';
import { Card, CardDescription, CardHeader } from '../../../ui/card';
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '../../../ui/dialog';

export function ApplyPriceList() {
	const { t } = useTranslation();
	// Placeholder catalogue data until the price list API exists; names are business content, not UI chrome.
	const card = [
		{
			title: 'Standard Repair Prices 2024',
			items: '4 Items',
		},
		{
			title: 'Premium Repair Prices 2024',
			items: '4 Items',
		},
		{
			title: 'Emergency Repair Prices 2024',
			items: '4 Items',
		},
	];

	return (
		<Dialog>
			<form>
				<DialogTrigger asChild>
					<Button
						variant="outline"
					>
						{t('finance.items.applyPriceList')}
					</Button>
				</DialogTrigger>
				<DialogContent className='max-w-5xl! max-h-screen'>
					<DialogHeader>
						<DialogTitle>{t('finance.items.applyPriceList')}</DialogTitle>
					</DialogHeader>
					<div className="grid grid-cols-2 gap-6 h-125">
						<div className="space-y-2">
							<h3 className="text-sm font-semibold text-muted-foreground mb-3">{t('finance.items.selectPriceList')}</h3>
							<div className="space-y-2 max-h-112.5 overflow-y-auto">
								{card.map((item) => (
									<Card
										key={item.title}
										className="p-4 rounded-lg border-2 cursor-pointer transition-all hover:border-blue-400 gap-0 shadow-none"
									>
										<CardHeader className="font-medium p-0 gap-0">{item.title}</CardHeader>
										<CardDescription className="text-sm mt-1">{item.items}</CardDescription>
									</Card>
								))}
							</div>
						</div>
						<div className="space-y-2">
							<h3 className="text-sm font-semibold text-zinc-700 mb-3">{t('finance.items.preview')}</h3>
							<div className="bg-card border border-dashed rounded-lg h-112.5 flex items-center justify-center text-muted-foreground">
								{t('finance.items.previewPlaceholder')}
							</div>
						</div>
					</div>
					<DialogFooter className="flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2">
						<DialogClose asChild>
							<Button
								variant="outline"
							>
								{t('common.actions.cancel')}
							</Button>
						</DialogClose>
						<Button>
							{t('finance.items.choosePriceList')}
						</Button>
					</DialogFooter>
				</DialogContent>
			</form>
		</Dialog>
	);
}
